import type { ReactNode } from "react";
import { Button, Dialog, vars } from "@pack-it-up/ui-web";

// The permanent-delete confirm shared by My Trips and My Templates: guards the
// destructive action behind a named "<x> will be deleted for everyone" prompt.
export const ConfirmDeleteDialog = ({
  name,
  onCancel,
  onConfirm,
}: {
  name: string | null;
  onCancel: () => void;
  onConfirm: () => void;
}): ReactNode => (
  <Dialog
    open={name !== null}
    onClose={onCancel}
    compact
    title="Delete permanently?"
    {...(name !== null ? { subtitle: `"${name}" will be deleted for everyone. This can't be undone.` } : {})}
    footer={
      <>
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          Delete
        </Button>
      </>
    }
  >
    <p style={{ color: vars.color.textMuted, fontSize: vars.font.sizeSm, margin: 0 }}>
      Restoring is safer if you might want it back later.
    </p>
  </Dialog>
);
